// @flow
import type { DirectusBlocksType } from 'types/Directus';

// fid_badges
export type FidBadgeType = {
  id_badge: number,
  title: string,
  description: string,
  type: 'transactionnel' | 'implication' | 'interaction',
  level: number,
  logo: string,
  logo_non_debloque: string,
  modal_badge_non_debloque: number | null,
  modal_badge_obtenu: number | null,
  modal_badge_nouveau: number | null,
  surprise: number | null
};

export type FidBadgesType = {
  fid_badges: FidBadgeType[],
  fid_badges_error: any
};

export const nullFidBadges = {
  fid_badges: [],
  fid_badges_error: false
};

// fid_modales
type ModalType = {
  id: number,
  content_title: string,
  name: string,
  content_description_1: DirectusBlocksType,
  content_description_2: DirectusBlocksType,
  logo: string,
  has_button_one: boolean | null,
  has_button_two: boolean | null,
  cta_button_one: string | null,
  cta_button_two: string | null
};
export type FidModalesType = {
  fid_modales: ModalType[],
  fid_modales_error: string
};

export const nullFidModales = {
  fid_modales: [],
  fid_modales_error: ''
};

// fid_offres
export type FidOffresType = {
  fid_offres: OfferType[],
  fid_offres_error: string
};

export type OfferType = {
  color: string,
  conditions?: Object,
  date_created: string,
  date_updated: string,
  external_identifier?: string,
  id_offre: number,
  identifiant: string,
  logo?: string,
  points: string,
  reward_type: string,
  seuil: string,
  source: number,
  status: string,
  texte?: Object,
  instructions?: Object,
  titre: string,
  type: number,
  type_offre: {
    id_offre_type: number,
    user_created: string,
    user_updated: string,
    date_created: string,
    date_updated: string,
    color: string,
    icon?: string,
    priority: string,
    title: string
  },
  vouchers_limited: Boolean,
  vouchers_list?: string
};

export const nullFidOffres = {
  fid_offres: [],
  fid_offres_error: ''
};
